import styled from 'styled-components'

export const SliderOuter = styled.div`
  position: relative;
`

export const SliderContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  border-radius: 13px;
  box-shadow: 0 0 12px 1px rgba(0, 0, 0, 0.34);
  max-width: ${({ maxWidth }) => maxWidth || '100%'};
  min-height: ${({ minHeight }) => minHeight || '550px'};
  margin: 0 auto;
  border: 2px solid rgba(123, 123, 123, 0.23);
  @media only screen and (max-width: 500px) {
    ${({ mobileMinHeight }) =>
      mobileMinHeight && `min-height: ${mobileMinHeight}`};
  }
`

export const Dot = styled.span`
  font-size: 2.2rem;
  margin: 0 4px;
  font-family: Arial;
  cursor: pointer;
  text-shadow: 1px 1px 1px #fff;
  user-select: none;
  z-index: 15;
  color: ${({ theme }) => theme.colors.secondary};
`
export const Dots = styled.span`
  display: flex;
  position: absolute;
  align-items: flex-end;
  justify-content: center;
  color: ${({ theme }) => theme.colors.grey1};
  bottom: ${({ outerControls }) => (outerControls ? '-46px' : '2.8rem')};
  width: 100%;

  max-width: ${({ maxWidth }) => maxWidth || '100%'};
  z-index: 14;
`

export const ArrowWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.label};
  border-radius: 4px;
  height: 44px;
  width: 44px;
  position: absolute;
  top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: ease all 0.3s;
  &:hover {
    filter: brightness(1.05);
  }
  ${({ right }) => (right ? 'right: -30px;' : 'left: -30px;')}
  > svg {
    ${({ right }) => (!right ? 'transform: rotate(-180deg);' : '')}
  }
  @media only screen and (max-width: 580px) {
    display: none;
  }
`
